import React from 'react';
import { isPhoneNumberValid } from '../utils/email-validation';

const PhoneInput = ({
  phoneNumber,
  setPhoneNumber,
  classNames,
  id,
  ariaDescribedby,
  error,
  setError,
  isBlurred,
  setIsBlurred,
  PhonePlaceholder,
  PhoneErrorMessage
}) => {
  const validatePhoneNumber = () => {
    const phoneNumberIsValid = isPhoneNumberValid(phoneNumber);
    if (!phoneNumberIsValid && phoneNumber) {
      setError(PhoneErrorMessage || 'Please enter a valid phone number.');
    } else {
      setError('');
    }
  };

  const handleBlur = () => {
    setIsBlurred(true);
    validatePhoneNumber();
  };

  const formatPhoneNumber = (e) => {
    const { value } = e.target;
    const cleaned = value.replace(/\D/g, '');
    const match = cleaned.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    setPhoneNumber(!match[2] ? match[1] : `(${match[1]}) ${match[2]}${match[3] ? `-${match[3]}` : ''}`);
  };

  return (
    <div>
      <input
        // eslint-disable-next-line max-len
        className={`body-2 ${classNames} w-full rounded-[30px] border border-solid border-default px-6 py-3 placeholder:text-default focus:border-default focus:outline-none focus:ring-2 focus:ring-default`}
        type="tel"
        name="phone"
        id={id}
        placeholder={PhonePlaceholder || "Enter your phone number"}
        value={phoneNumber}
        onBlur={handleBlur}
        onChange={(e) => formatPhoneNumber(e)}
        aria-describedby={ariaDescribedby}
        required
      />
      {isBlurred && error !== '' && (
        <p
          id="smsHelp"
          className="body-4 mt-1 pl-6 text-error"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default PhoneInput;
